import { render, staticRenderFns } from "./NotesOnContactPage.vue?vue&type=template&id=fbd7ba54&"
import script from "./NotesOnContactPage.vue?vue&type=script&lang=js&"
export * from "./NotesOnContactPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbd7ba54')) {
      api.createRecord('fbd7ba54', component.options)
    } else {
      api.reload('fbd7ba54', component.options)
    }
    module.hot.accept("./NotesOnContactPage.vue?vue&type=template&id=fbd7ba54&", function () {
      api.rerender('fbd7ba54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/notes/NotesOnContactPage.vue"
export default component.exports